import { NavLink } from "react-router-dom";
import Logo from "../../assets/150x150.png";
import "./style.css";
import { useState, useEffect } from "react";
import api from "../../services/api";
import { podeAcessar } from "../../componente/permissoes";

function Header() {   
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
        <div className="container-fluid">
          <NavLink className="navbar-brand Menu Logo1" to="/home">
            <img className="Logo1" src={Logo} alt="logo" />
          </NavLink>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="collapse navbar-collapse container-fluid"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <label
                  className="nav-link dropdown-toggle active Menu item"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Cadastros
                </label>
                <ul className="dropdown-menu">
                  <li hidden={!podeAcessar("/cadastro/empresa")}>
                    <NavLink to="/cadastro/empresa" className="dropdown-item">
                      Empresa
                    </NavLink>
                  </li>
                  <li hidden={!podeAcessar("/cadastro/funcionario")}>
                    <NavLink
                      to="/cadastro/funcionario"
                      className="dropdown-item"
                    >
                      Funcionário
                    </NavLink>
                  </li>
                  <li hidden={!podeAcessar("/cadastro/usuario")}>
                    <NavLink to="/cadastro/usuario" className="dropdown-item">
                      Usuário
                    </NavLink>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li hidden={!podeAcessar("/cadastro/grupoproduto")}>
                    <NavLink
                      to="/cadastro/grupoproduto"
                      className="dropdown-item"
                    >
                      Grupo de Produto
                    </NavLink>
                  </li>
                  <li hidden={!podeAcessar("/cadastro/produto")}>
                    <NavLink to="/cadastro/produto" className="dropdown-item">
                      Produto
                    </NavLink>
                  </li>
                  <li hidden={!podeAcessar("/cadastro/kit")}>
                    <NavLink to="/cadastro/kit" className="dropdown-item">
                      Kit
                    </NavLink>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li hidden={!podeAcessar("/cadastro/equipe")}>
                    <NavLink to="/cadastro/equipe" className="dropdown-item">
                      Equipe
                    </NavLink>
                  </li>
                  <li hidden={!podeAcessar("/cadastro/cliente")}>
                    <NavLink to="/cadastro/cliente" className="dropdown-item">
                      Cliente
                    </NavLink>
                  </li>
                  <li hidden={!podeAcessar("/cadastro/fornecedor")}>
                    <NavLink
                      to="/cadastro/fornecedor"
                      className="dropdown-item"
                    >
                      Fornecedor
                    </NavLink>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li hidden={!podeAcessar("/cadastro/categoriafinanceira")}>
                    <NavLink
                      to="/cadastro/categoriafinanceira"
                      className="dropdown-item"
                    >
                      Categorias Financeiras
                    </NavLink>
                  </li>
                  <li hidden={!podeAcessar("/cadastro/condicoespagamento")}>
                    <NavLink
                      to="/cadastro/condicoespagamento"
                      className="dropdown-item"
                    >
                      Condições de Pagamento
                    </NavLink>
                  </li>
                  <li hidden={!podeAcessar("/cadastro/caixabanco")}>
                    <NavLink
                      to="/cadastro/caixabanco"
                      className="dropdown-item"
                    >
                      Caixas e Bancos
                    </NavLink>
                  </li>
                </ul>
              </li>

              <li className="nav-item">
                <label
                  className="nav-link dropdown-toggle active item"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Operações
                </label>
                <ul className="dropdown-menu">
                  <li hidden={!podeAcessar("/operacoes/lanctitulo")}>
                    <NavLink
                      to="/operacoes/lanctitulo"
                      className="dropdown-item"
                    >
                      Lançamento de Repasse
                    </NavLink>
                  </li>
                  {/*<li hidden={!podeAcessar("/operacoes/lancdespesa")}>
                    <NavLink
                      to="/operacoes/lancdespesa"
                      className="dropdown-item"
                    >
                      Lançamento de Despesa
                    </NavLink>
                  </li>*/}
                  {/*<li hidden={!podeAcessar("/operacoes/lancfolhapagamento")}>
                    <NavLink
                      to="/operacoes/lancfolhapagamento"
                      className="dropdown-item"
                    >
                      Folha de Pagamento
                    </NavLink>
                  </li>*/}
                  {/*<li>
                    <hr className="dropdown-divider" />
                  </li>*/}
                  {/* <li hidden={!podeAcessar("/operacoes/caixa")}>
                    <NavLink to="/operacoes/caixa" className="dropdown-item">
                      Caixa
                    </NavLink>
                  </li>*/}
                  {/*<li hidden={!podeAcessar("/operacoes/manutencao")}>
                    <NavLink
                      to="/operacoes/manutencao"
                      className="dropdown-item"
                    >
                      Manutenção
                    </NavLink>
                  </li>*/}
                  {/*<li>
                    <hr className="dropdown-divider" />
                  </li>*/}
                  {/*<li hidden={!podeAcessar("/operacoes/viagem")}>
                    <NavLink to="/operacoes/viagem" className="dropdown-item">
                      Informar Viagem
                    </NavLink>
                  </li>*/}
                  {/*<li hidden={!podeAcessar("/operacoes/gerarficha")}>
                    <NavLink
                      to="/operacoes/gerarficha"
                      className="dropdown-item"
                    >
                      Gerar Fichas
                    </NavLink>
                  </li>*/}
                </ul>
              </li>

              <li className="nav-item">
                <label
                  className="nav-link dropdown-toggle active item"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Relatórios
                </label>
                <ul className="dropdown-menu">
                  <li hidden={!podeAcessar("/relatorio/cliente")}>
                    <NavLink to="/relatorio/cliente" className="dropdown-item">
                      Clientes
                    </NavLink>
                  </li>
                  {/*<li hidden={!podeAcessar("/relatorio/fichavinculada")}>
                    <NavLink
                      to="/relatorio/fichavinculada"
                      className="dropdown-item"
                    >
                      Fichas Vinculadas
                    </NavLink>
                  </li> */}
                  <li hidden={!podeAcessar("/relatorio/fichacobrar")}>
                    <NavLink
                      to="/relatorio/fichacobrar"
                      className="dropdown-item"
                    >
                      Fichas Cobrar
                    </NavLink>
                  </li>
                  <li hidden={!podeAcessar("/relatorio/vendaemaberto")}>
                    <NavLink
                      to="/relatorio/vendaemaberto"
                      className="dropdown-item"
                    >
                      Vendas Em Aberto
                    </NavLink>
                  </li>
                  <li hidden={!podeAcessar("/relatorio/vendaporvendedor")}>
                    <NavLink
                      to="/relatorio/vendaporvendedor"
                      className="dropdown-item"
                    >
                      Vendas Por Vendedor
                    </NavLink>
                  </li>
                  <li hidden={!podeAcessar("/relatorio/vendaporequipe")}>
                    <NavLink
                      to="/relatorio/vendaporequipe"
                      className="dropdown-item"
                    >
                      Vendas Por Equipe
                    </NavLink>
                  </li>
                  {/*<li hidden={!podeAcessar("/cadastro/empresa")}>
                    <NavLink
                      to="/relatorio/fichacobradas"
                      className="dropdown-item"
                    >
                      Fichas Cobradas
                    </NavLink>
                  </li>*/}
                </ul>
              </li>
            </ul>
            <ul className="navbar-nav">
              <div>
                <p className="Versao">0.0.0.101</p>
              </div>

              <div>
                <NavLink className="Menu Item" to="/" end>
                  Sair
                </NavLink>
              </div>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Header;
